<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";

	const { breadcrumb, active }: { breadcrumb: Breadcrumb; active: boolean } = $props();
</script>

<svelte:element
	this={breadcrumb.href !== undefined ? "a" : "span"}
	href={breadcrumb.href}
	class="text-fcrgray [a&]:underline text-xs/normal font-medium"
	aria-current={active ? "page" : undefined}
>
	<Formatted text={breadcrumb.label} />
</svelte:element>
